exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1kee2_i5xp-Caz58HDXcXC{display:inline-block;position:relative}", ""]);

// exports
exports.locals = {
	"draggableContainer": "_1kee2_i5xp-Caz58HDXcXC"
};